export class MultiStopGradientCalculator {
  constructor(stops) {
    this.stops = stops
    this.gradients = []
    for (let i = 1; i < this.stops.length; i++) {
      const start = this.stops[i - 1]
      const end = this.stops[i]
      this.gradients.push(new GradientCalculator(start.color, end.color, end.step - start.step))
    }
  }

  getIndicatorColor(level, alpha, noValueColor) {
    if (!Number.isInteger(level)) {
      return noValueColor || 'rgb(255, 255, 255)'
    }

    let i
    let start = null
    for (i = 0; i < this.gradients.length; i++) {
      start = this.stops[i]
      const end = this.stops[i + 1]
      if (level >= start.step && level <= end.step) {
        break
      }
    }

    return this.gradients[i].getIndicatorColor(level - start.step, alpha, noValueColor)
  }
}

export class ProtectionLevelGradientCalculator extends MultiStopGradientCalculator {
  constructor() {
    const stops = [
      { color: 'rgb(76, 175, 80)', step: 0 },
      { color: 'rgb(255, 193, 7)', step: 250 },
      { color: 'rgb(211, 47, 47)', step: 1000 }
    ]
    super(stops)
  }
}

export class GradientCalculator {
  constructor(start, end, steps) {
    this._steps = steps
    this._stepFactor = 1 / (this._steps - 1)

    // get the color values out of the start RGB strings
    start = start.match(/\d+/g).map(Number)
    end = end.match(/\d+/g).map(Number)

    this._start = start
    this._end = end
  }

  __parts(step) {
    // cap to beginning or end
    step = step < 0 ? 0 : step >= this._steps ? this._steps - 1 : step

    let parts = this._start.slice()
    for (let i = 0; i < 3; i++)
      parts[i] = Math.round(parts[i] + this._stepFactor * step * (this._end[i] - this._start[i]))

    return parts
  }

  rgbColor(step) {
    return `rgb(${this.__parts(step)})`
  }

  rgbaColor(step, alpha) {
    return `rgba(${this.__parts(step)}, ${alpha})`
  }

  getIndicatorColor(level, alpha, noValueColor) {
    if (!Number.isInteger(level)) return noValueColor || 'rgb(255, 255, 255)'

    return alpha ? this.rgbaColor(level, alpha) : this.rgbColor(level)
  }
}

export class TextColorCalculator {
  static getTextColor(backgroundRgbColor, lightTextColor, darkTextColor) {
    let cleanString = backgroundRgbColor.toLowerCase().replace(/[^0-9,]/g, '')
    let parts = cleanString.split(',')
    if (parts == null || parts.length != 3) return darkTextColor

    let r = parseInt(parts[0])
    let g = parseInt(parts[1])
    let b = parseInt(parts[2])
    let uicolors = [r / 255, g / 255, b / 255]
    let c = uicolors.map(col => {
      if (col <= 0.03928) return col / 12.92

      return Math.pow((col + 0.055) / 1.055, 2.4)
    })
    let L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]
    return L > 0.179 ? darkTextColor : lightTextColor
  }
}

export class ColorShadeCalculator {
  static adjustShade(rgbColor, magnitude) {
    let cleanString = rgbColor.toLowerCase().replace(/[^0-9,]/g, '')
    let parts = cleanString.split(',')
    if (parts == null || parts.length < 3) return rgbColor

    let r = parseInt(parts[0]) + magnitude
    if (r > 255) r = 255
    else if (r < 0) r = 0

    let g = parseInt(parts[1]) + magnitude
    if (g > 255) g = 255
    else if (g < 0) g = 0

    let b = parseInt(parts[2]) + magnitude
    if (b > 255) b = 255
    else if (b < 0) b = 0

    return `rgb(${r}, ${g}, ${b})`
  }
}

export default {
  GradientCalculator,
  MultiStopGradientCalculator,
  ProtectionLevelGradientCalculator,
  TextColorCalculator,
  ColorShadeCalculator
}
